import copyToClipboard from "util/copyToClipboard";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
const CopyValueToClipboard = ({ value }) => copyToClipboard(value);
const isEnabled = ({ contexts }) => !hasMultipleValueForActions(contexts);
CopyValueToClipboard.isEnabled = isEnabled;
export default CopyValueToClipboard;
